import React, { useState, useEffect, ChangeEvent, useCallback } from 'react';

import { Box, TextField, SelectChangeEvent } from '@mui/material';

import { ElementProps } from '../../../@types/forms/types';

//-----------------------------------------------------

type InputFieldElementProps = {
  isChild?: boolean;
  el: ElementProps;
  scaledDimensions: {
    x?: number;
    y?: number;
    width?: number;
    height?: number;
    fontSize: number;
  };
  elementContentValue?: string[] | undefined;
  handleTextAlign: (alignEnum: number) => string;
  handleInputFieldChange?: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent,
    el: ElementProps
  ) => void;
  pageNumberScale: number;
  collaboratorColor?: string;
  disabled?: boolean;
  errorMessage?: string;
};

const InputFieldElement: React.FC<InputFieldElementProps> = ({
  isChild,
  el,
  scaledDimensions,
  elementContentValue,
  handleTextAlign,
  handleInputFieldChange,
  pageNumberScale,
  collaboratorColor,
  disabled = false,
  errorMessage,
}) => {
  const [value, setValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (elementContentValue && elementContentValue.length > 0) {
      setValue(elementContentValue[0]);
    } else {
      setValue(undefined);
    }
  }, [elementContentValue]);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      handleInputFieldChange && handleInputFieldChange(event, el);
      setValue(event.target.value);
    },
    [handleInputFieldChange, el]
  );

  return (
    <Box
      sx={{
        backgroundColor: collaboratorColor,
        borderRadius: 1,
        width: '100%',
      }}
    >
      <TextField
        disabled={isChild || disabled}
        value={value}
        fullWidth
        multiline
        size="small"
        error={!!errorMessage}
        helperText={errorMessage || null}
        placeholder={` ${el.label}`}
        slotProps={{
          htmlInput: {
            sx: {
              color: el.color,
              fontSize: `${el.fontSize * pageNumberScale}px`,
              fontFamily: `${el.font}`,
              textAlign: handleTextAlign(el.textAlignment),
              fontWeight: el.textStyle.includes('Bold') ? 'Bold' : 'Regular',
              fontStyle: el.textStyle.includes('Italic') ? 'italic' : 'normal',
              textDecoration: el.textDecoration === 1 ? 'underline' : '',
            },
          },
        }}
        id={el.id}
        variant="standard"
        onChange={handleChange}
        sx={{
          width: '100%',
          maxWidth: '100%',
        }}
      />
    </Box>
  );
};

export default InputFieldElement;
